<bic-popup (close)="dialogRef.close()" [hasBackdrop]="true"
           [title]="'Prüfeinstellungen'"
           customClass="w-[600px]">
  <form [formGroup]="taskForm" bicPopupContent>
    <div class="flex flex-col justify-start items-start w-full gap-4 overflow-hidden">
      <div class="w-full flex flex-col gap-4">

        @for (parameter of parameters; track parameter) {
          @if (parameter.type == Parameter.TypeEnum.BOOL) {
            <bic-select (blur)="taskForm.get(parameter.value)?.markAsTouched()" (focus)="taskForm.get(parameter.value)?.markAsUntouched()" [errorCondition]="taskForm.get(parameter.value)?.touched && taskForm.get(parameter.value)?.invalid"
                        [formControlName]="parameter.value"
                        [label]="parameter.name"
                        [placeholder]="placeholder[parameter.value]"
                        [required]="true">
              <bic-dropdown-element [value]="true">Ja</bic-dropdown-element>
              <bic-dropdown-element [value]="false">Nein</bic-dropdown-element>
            </bic-select>
          }
          @if (parameter.type == Parameter.TypeEnum.INT) {
            @if (parameter.value != 'building_class') {
              <bic-input (blur)="taskForm.get(parameter.value)?.markAsTouched()"
                         (focus)="taskForm.get(parameter.value)?.markAsUntouched()" [customStepSize]="true"
                         [errorCondition]="taskForm.get(parameter.value)?.touched && taskForm.get(parameter.value)?.invalid"
                         [formControlName]="parameter.value" [formGroup]="taskForm" [label]="parameter.name"
                         [min]="0"
                         [placeholder]="placeholder[parameter.value]"
                         [required]="true"
                         [showX]="false" [stepSize]="1" [type]="'number'">
              </bic-input>
            }
            @if (parameter.value == 'building_class') {
              <bic-select (blur)="taskForm.get(parameter.value)?.markAsTouched()"
                          (focus)="taskForm.get(parameter.value)?.markAsUntouched()"
                          [errorCondition]="taskForm.get(parameter.value)?.touched && taskForm.get(parameter.value)?.invalid"
                          [formControlName]="parameter.value" [formGroup]="taskForm"
                          [label]="parameter.name"
                          [placeholder]="placeholder[parameter.value]"
                          [required]="true"
                          [showX]="false">
                <bic-dropdown-element [value]="1">Gebäudeklasse 1</bic-dropdown-element>
                <bic-dropdown-element [value]="2">Gebäudeklasse 2</bic-dropdown-element>
                <bic-dropdown-element [value]="3">Gebäudeklasse 3</bic-dropdown-element>
                <bic-dropdown-element [value]="4">Gebäudeklasse 4</bic-dropdown-element>
                <bic-dropdown-element [value]="5">Gebäudeklasse 5</bic-dropdown-element>
              </bic-select>
            }
          }
          @if (parameter.type == Parameter.TypeEnum.FLOAT) {
            <bic-input (blur)="taskForm.get(parameter.value)?.markAsTouched()"
                       (focus)="taskForm.get(parameter.value)?.markAsUntouched()"
                       [errorCondition]="taskForm.get(parameter.value)?.touched && taskForm.get(parameter.value)?.invalid"
                       [formControlName]="parameter.value" [formGroup]="taskForm" [label]="parameter.name"
                       [placeholder]="placeholder[parameter.value]"
                       [required]="true"
                       [showX]="false"
                       [type]="'number'">
            </bic-input>
          }
          @if (parameter.type == Parameter.TypeEnum.ENUM) {
            <bic-select (blur)="taskForm.get(parameter.value)?.markAsTouched()" (focus)="taskForm.get(parameter.value)?.markAsUntouched()" [errorCondition]="taskForm.get(parameter.value)?.touched && taskForm.get(parameter.value)?.invalid"
                        [formControlName]="parameter.value"
                        [label]="parameter.name"
                        [placeholder]="placeholder[parameter.value]"
                        [required]="true">
              @for (parameterEnum of parameter.enums; track parameterEnum) {
                <bic-dropdown-element [value]="parameterEnum.value">{{ parameterEnum.name }}</bic-dropdown-element>
              }
            </bic-select>
          }
        }


        <div (click)="setCheckbox()" class="flex pt-2 gap-2 items-center">
          <input (click)="setCheckbox(); $event.stopPropagation()" [checked]="saveSettings"
                 class="w-4 h-4 !text-green bg-gray-50 rounded focus:ring-[none] border border-gray-300"
                 type="checkbox"
                 value="">
          <label>Angaben im Projekt speichern</label>
        </div>
      </div>
    </div>
  </form>

  <div bicPopupButtonGroup class="flex flex-row justify-end gap-4">
    <div class="flex-grow"></div>
    <bic-button buttonType="white" mat-dialog-close
    >Abbrechen
    </bic-button>
    <bic-button (click)="check()" [disabled]="!taskForm.valid">Weiter</bic-button>
  </div>

</bic-popup>
